<button mat-icon-button matTooltip=""
        (click)="openFaqDialog()"
        aria-label="Open FAQ"
        class="help-fab">
    <mat-icon>help_outline</mat-icon>
</button>
